<app-dropdown class="make-model-dropdown">
  <app-dropdown-button
    [color]="makeCount ? 'light' : 'default'"
    [active]="active"
    [small]="small"
    [mobile-small]="mobileSmall"
    (activeChange)="toggle($event)"
    [label]="type === 'make' ? (makeCount ? ('filter.makeAndModel.addAnotherMake' | translate) : ('filter.makeAndModel.addMake' | translate)) : type === 'model' ? ('filter.makeAndModel.addModel' | translate) : ('filter.makeAndModel.addMakeModel' | translate)"
    [value]="selectedCount && type === 'default' ? (singleModel ?? ('filter.makeAndModel.selectedModels' | translate: { count: selectedCount })) : undefined"
    (clicked)="hidePopover()"
  ></app-dropdown-button>
  <app-dropdown-main [title]="(type !== 'model' && step === 1 ? 'filter.makeAndModel.makeTitle' : 'filter.makeAndModel.modelTitle') | translate" [align]="align" [active]="active" [position]="topFilter ? 'absolute' : position" (closed)="toggle(false)">
    @if (type !== 'model' && step === 1) {
      <app-dropdown-header>
        <app-search-input [placeholder]="'filter.makeAndModel.searchMake' | translate" [(value)]="search" (valueChange)="searchChanged()"></app-search-input>
      </app-dropdown-header>
    }
    <app-dropdown-content class="notranslate" [height]="step === 1 ? 380 : undefined">
      @if (type !== 'model' && step === 1) {
        @if (data) {
          <app-dropdown-row>
            <app-dropdown-list>
              @for (item of data; track $index) {
                @if (item.titleWithoutDiacritics?.startsWith(searchWithoutDiacritics)) {
                  <app-dropdown-list-item
                    [ngClass]="{ 'make-model-dropdown__active-item': value[item.id] && value[item.id].models && value[item.id].models.length > 0 }"
                    [value]="item.id"
                    [href]="globals.routes()['list'].url + '/' + item.slug"
                    [count]="undefined"
                    [active]="value[item.id] && value[item.id].models && value[item.id].models.length > 0"
                    (clicked)="selectMake({ id: item.id, title: item.title, logo: item.logo, slug: item.slug, models: item.model })"
                  >
                    @if (item.logo) {
                      <div class="make-model-dropdown__image">
                        <app-image class="make-model-dropdown__image-main" [src]="item.logo" [alt]="item.title" [fill]="true" [object-fit]="'contain'" [placeholder]="false"></app-image>
                      </div>
                    }
                    {{ item.title }}
                  </app-dropdown-list-item>
                }
              }
            </app-dropdown-list>
          </app-dropdown-row>
        } @else {
          <app-loader></app-loader>
        }
      } @else {
        @if (type !== 'model') {
          <button class="make-model-dropdown__back" type="button" (click)="back()"><app-icon [icon]="'chevron'" [width]="16" [rotate]="180"></app-icon> {{ 'globals.back' | translate }}</button>
        }
        @if (models?.length) {
          <app-dropdown-list>
            @if (!single && !list) {
              <app-dropdown-list-item [type]="'checkbox'" [value]="'all'" [href]="globals.routes()['list'].url + '/' + activeMake.slug" [(active)]="selectedAll" [name]="'all-models'" [count]="undefined" (clicked)="selectAllModels(true)">{{ 'globals.selectAll' | translate }}</app-dropdown-list-item>
            }
            @for (item of models; track item) {
              <app-dropdown-list-item
                [type]="'list'"
                [value]="item.id"
                [href]="globals.routes()['list'].url + '/' + activeMake.slug + '/' + item.slug"
                [active]="item.checked"
                (activeChange)="$event === true ? (item.checked = true) : null"
                [name]="single ? 'model' : 'model-' + item.id"
                [count]="undefined"
                (clicked)="selectModel($event, item.title)"
              >
                {{ item.title }}
              </app-dropdown-list-item>
            }
          </app-dropdown-list>
        }
        @if (!models) {
          <app-loader></app-loader>
        }
      }
    </app-dropdown-content>
    @if (!single && !list) {
      <app-dropdown-sticky-bottom>
        <app-link [color]="'secondary'" (clicked)="step === 2 || type === 'model' ? reset(activeMake.id) : reset()">{{ 'globals.reset' | translate }}</app-link>
        <app-button [size]="'small'" (clicked)="toggle(false)">{{ 'forms.save' | translate }}</app-button>
      </app-dropdown-sticky-bottom>
    }
  </app-dropdown-main>
</app-dropdown>
